import { productIdMappings, CourseKey } from './productIdMappings'

let hasLoggedSkillsTutorEnv = false

/**
 * Get current environment name
 */
const getCurrentEnvironment = (): 'uat' | 'prod' => {
  const rawEnvName = typeof process !== 'undefined' ? process.env.ENV_NAME : undefined
  const envName = rawEnvName ? rawEnvName.toLowerCase() : ''

  // Prefer explicit ENV_NAME. Supported values: 'uat' | 'production'.
  // Default to production to avoid accidentally using UAT mappings when env is missing.
  const selected = envName === 'uat' ? 'uat' : 'prod'

  if (!hasLoggedSkillsTutorEnv) {
    hasLoggedSkillsTutorEnv = true
    console.info('[SkillsTutorCourseKey] selectedEnvironment', {
      selected,
      ENV_NAME: rawEnvName,
    })
  }

  return selected
}

/**
 * Returns productId -> courseKey mapping
 * based on current environment
 */
export const getSkillsTutorCourseKeyMap = (): Record<string, CourseKey> => {
  const env = getCurrentEnvironment()
  const mappings = productIdMappings[env]

  const result: Record<string, CourseKey> = {}

  for (const courseKey of Object.keys(mappings) as CourseKey[]) {
    const productId = mappings[courseKey]
    result[productId] = courseKey
  }

  return result
}

// Export for direct access if needed
export { productIdMappings }
export type { CourseKey }
